import Container from "@mui/material/Container";
import Card from '@mui/material/Card';
import CardMedia from "@mui/material/CardMedia";
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import PetitCampusPosterImage from './PetitCampusPoster.jpg'

function PetitCampusPoster() {
    return (
        <Container className='container'>
            <Box className='bgimg3alt'>
            <Card>
                <Link to='/About'>
                
                <CardMedia
                    image={PetitCampusPosterImage}
                    sx={{ height: '500px', backgroundSize: 'contain' }}
                />
                </Link>
            </Card>
            </Box>
        </Container>
    )
}

export default PetitCampusPoster;
